// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1715":"2d56fe57","4741":"570f83af","5791":"35c8a871","7082":"533240bd","9418":"ca562865"}[chunkId] + ".chunk.css";
};